<template>
    <div class="rounded-2xl border border-theme-border px-4 py-2">
        <div class="flex items-center justify-between gap-3">
            <span class="text-sm font-semibold text-theme-base">
                tucatalogo.co footer
            </span>
            <div class="flex items-center gap-2">
                <button
                    v-if="locked"
                    type="button"
                    class="flex h-6 w-6 items-center justify-center rounded-full bg-brand-gray text-xs text-white"
                    aria-label="Ver planes para ocultar el footer"
                    @click="$emit('upgrade')"
                >
                    🔒
                </button>
                <custom-switch
                    :value="value"
                    :disabled="loading"
                    success
                    @input="onToggle"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CustomSwitch from "@/components/utils/CustomSwitch.vue";

export default {
    name: "TucatalogoFooterCard",
    components: { CustomSwitch },
    props: {
        value: { type: Boolean, default: true },
        locked: { type: Boolean, default: false },
        loading: { type: Boolean, default: false }
    },
    methods: {
        onToggle(visible) {
            if (this.locked) {
                this.$emit("upgrade");
                return;
            }
            this.$emit("input", visible);
        }
    }
};
</script>
